import styled from 'styled-components';

export const Content = styled.div`
  padding: 10px;
  margin: 0 auto;
  width: 80%;
  box-shadow: 0px 0px 5px 5px rgba(56, 56, 56, 0.2);
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
`;

export const Input = styled.input`
  padding: 5px;
  margin-top: 10px;
  height: 35px;
  width: 100%;
`;
